export default "__VITE_ASSET__5cbe1338__"